// initial state
// shape: [{ id, quantity }]
const state = {
    isExperienceEditor: false

};

// actions
const actions = {
    changeIsExperienceEditor({ commit }, payload) {
        commit('setIsExperienceEditor', payload);
    }

};

// mutations
const mutations = {
    setIsExperienceEditor(state, val) {
        state.isExperienceEditor = val;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
